var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2214 1.14645C11.4167 0.951184 11.7333 0.951184 11.9286 1.14645L14.8536 4.07145C15.0488 4.26671 15.0488 4.58329 14.8536 4.77855L4.77855 14.8536C4.68479 14.9473 4.55761 15 4.425 15H1.5C1.22386 15 1 14.7761 1 14.5V11.575C1 11.4424 1.05268 11.3152 1.14645 11.2214L11.2214 1.14645ZM2 11.7821V14H4.21789L12.3304 5.8875L10.1125 3.66961L2 11.7821ZM10.8196 2.9625L13.0375 5.18039L13.7929 4.425L11.575 2.20711L10.8196 2.9625Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f0fbedd388517af033154cb527b6c08f.svg";
export { ForwardRef as ReactComponent };